import { render, staticRenderFns } from "./SettingsGeneral.vue?vue&type=template&id=0264d9df&scoped=true&"
import script from "./SettingsGeneral.vue?vue&type=script&lang=ts&"
export * from "./SettingsGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0264d9df",
  null
  
)

export default component.exports